import * as categoryConst from 'app/constants/categories';
import { AppStoreState } from 'app/redux/store';
import { useTranslation } from 'next-i18next';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { Question } from 'types/test';
import { useState } from 'react';

interface ResultExplainProps {
  questionResult: Question | null;
}

const ResultExplain = (props: ResultExplainProps) => {
  const router = useRouter();
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const { process, test } = useSelector((state: AppStoreState) => state.test);

  const { questionResult } = props;
  if (process !== 'complete' || !questionResult?.explain) return <></>

  return (
    <div className="pl-2 mb-1">
      <a className="font-weight-bold text-info pb-1 cursor-pointer" onClick={() => setVisible(!visible)}>
        <u>{t('tests.explain')}</u>
        <span className="dropdown-toggle pl-1"></span>
      </a>
      <div className={`${!visible ? 'd-none' : ''} mt-1`}>
        <div className="card card-body" style={{ width: '100%' }}>
          <span
            className={categoryConst.IELTS_TEST.includes(test.category_id) ? 'explain-ielts' : 'explain-other'}
            dangerouslySetInnerHTML={{
              __html: router.locale == 'vi' ? questionResult?.explain : (questionResult?.en_explain || questionResult?.explain)
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default ResultExplain;
